<template>
  <b-modal :id="modalId" hide-header hide-footer size="lg" :modal-class="modalClass">
    <PermitApplicationForm :key="formKey" :presale-id="presaleId" :presale-title="presaleTitle"
      :application-ref="applicationRef" :placement="placement" :placement-fid="placementFid"
      :placement-uid="placementUid" :ptc-options="ptcOptions" :utc-options="utcOptions" @close="close"
      @saved="$emit('saved', $event)" />
  </b-modal>
</template>

<script>
import PermitApplicationForm from "../Forms/PermitApplicationForm.vue";

// The one add / edit Permit Application dialog. The Land tab (presale project
// page) and the Permit tab (UTC page) both open it, so the flow lives here once:
// the form's first step lets the user pick where the application is saved
// (presale project, one building / PTC or one component / UTC), limited to the
// buildings and components the caller passes in.
//
//   this.$refs.permitModal.open()                          new, starts on the presale project
//   this.$refs.permitModal.open({ placement: 'utc', uid }) new, starts on that component
//   this.$refs.permitModal.open({ nid })                   edit that application
export default {
  name: "PermitApplicationModal",
  components: { PermitApplicationForm },
  props: {
    modalId: { type: String, default: "permit-application-modal" },
    modalClass: { type: String, default: "" },
    presaleId: { type: [Number, String], default: null },
    presaleTitle: { type: String, default: "" },
    // [{ fid, name }] and [{ uid, fid, name, ptcName }]: what can be filed against.
    ptcOptions: { type: Array, default: () => [] },
    utcOptions: { type: Array, default: () => [] },
  },
  data() {
    return {
      // Remounts the form on every open so it never keeps a previous application.
      formKey: 0,
      applicationRef: null,
      placement: "main",
      placementFid: "",
      placementUid: "",
    };
  },
  methods: {
    open({ nid = null, placement = "main", fid = "", uid = "" } = {}) {
      this.applicationRef = nid || null;
      this.placement = placement;
      this.placementFid = fid ? String(fid) : "";
      this.placementUid = uid ? String(uid) : "";
      this.formKey += 1;
      this.$bvModal.show(this.modalId);
    },
    close() {
      this.$bvModal.hide(this.modalId);
    },
  },
};
</script>
